import React, { useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

function getCroppedBlob(imgEl, crop, mimeType) {
    const scaleX = imgEl.naturalWidth / imgEl.width;
    const scaleY = imgEl.naturalHeight / imgEl.height;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(crop.width * scaleX);
    canvas.height = Math.round(crop.height * scaleY);
    const ctx = canvas.getContext('2d');
    ctx.drawImage(
        imgEl,
        crop.x * scaleX, crop.y * scaleY,
        crop.width * scaleX, crop.height * scaleY,
        0, 0, canvas.width, canvas.height
    );
    return new Promise(resolve => canvas.toBlob(resolve, mimeType || 'image/jpeg', 0.95));
}

export default function CropImageModal({ src, mimeType, onConfirm, onCancel, confirmLabel = 'Confirm' }) {
    const imgRef = useRef(null);
    const [crop, setCrop] = useState({ unit: '%', width: 80, height: 80, x: 10, y: 10 });

    const handleConfirm = async () => {
        if (!imgRef.current || !crop.width || !crop.height) return;
        const blob = await getCroppedBlob(imgRef.current, crop, mimeType);
        const ext = mimeType === 'image/png' ? 'png' : mimeType === 'image/webp' ? 'webp' : 'jpg';
        const file = new File([blob], `cropped.${ext}`, { type: mimeType || 'image/jpeg' });
        onConfirm(file);
    };

    return (
        <Modal show onHide={onCancel} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '16px' }}>Crop Image</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center p-2" style={{ background: '#111', overflowY: 'auto', maxHeight: '70vh' }}>
                <ReactCrop
                    src={src}
                    crop={crop}
                    onChange={c => setCrop(c)}
                    onImageLoaded={img => { imgRef.current = img; }}
                    style={{ maxWidth: '100%' }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>Cancel</Button>
                <Button variant="primary" onClick={handleConfirm}>{confirmLabel}</Button>
            </Modal.Footer>
        </Modal>
    );
}
